import { Node } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    stickers: {
      setStickers: () => ReturnType;
    };
  }
}

export const StickersExtension = Node.create({
  name: 'stickers',

  group: 'stickers',

  content: 'sticker*',

  selectable: false,

  renderHTML({ HTMLAttributes }) {
    return ['div', { 'data-type': 'stickers' }, 0];
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="stickers"]',
      },
    ];
  },
});
